import BaseElement from './BaseElement'
import { WishlistSlideout } from '../components/WishlistSlideout'

export default class WishlistSlideoutElement extends BaseElement {
  static get observedAttributes () {
    return ['product', 'variant-selected-id', 'template-suffix', 'product-bi-line', 'variant-selected', 'properties-local', 'product-personalised-price']
  }

  renderElement () {
    const product = JSON.parse(this.getAttribute('product') as string)
    const variantSelected = JSON.parse(this.getAttribute('variant-selected') as string)
    const productBiline = this.getAttribute('product-bi-line') as string
    const variantSelectedId = parseInt(this.getAttribute('variant-selected-id') as string)
    const templateSuffix = this.getAttribute('template-suffix') as string
    const propertiesLocal = JSON.parse(this.getAttribute('properties-local') as string)
    const productPersonalisedPrice = this.getAttribute('product-personalised-price') && JSON.parse(this.getAttribute('product-personalised-price') as string)
    
    this.rootElement.render(<WishlistSlideout product={product} productBiline={productBiline} variantSelectedLocal={variantSelected} variantSelectedId={variantSelectedId} templateSuffix={templateSuffix} propertiesLocal={propertiesLocal} productPersonalisedPrice={productPersonalisedPrice} />)
  }
}
